// usePath.js
import { useLocation, matchPath } from "react-router-dom";

export default function usePath() {
    const { pathname, search, hash } = useLocation();

    // 자주 쓰는 편의 메서드들
    const is = (p) => pathname === p;
    const startsWith = (p) => pathname.startsWith(p);
    const includes = (p) => pathname.includes(p);

    // react-router 스타일 패턴 매칭 (예: /ranking/:type/*)
    const match = (pattern, opts = {}) =>
        !!matchPath({ path: pattern, end: opts.end ?? true }, pathname);

    return { pathname, search, hash, is, startsWith, includes, match };
}
